import styles from "./ColorIndicatorAtom.module.scss";
import ImageAtom from "../Image";
import assetLoader from "@utils/internalImageLoder";

export default function ColorIndicatorAtom({ color }: { color?: string }) {
  return (
    <div
      className={styles["indicator__wrapper"]}
      style={{
        backgroundColor: color || "transparent",
      }}
    >
      <ImageAtom
        src={`${assetLoader()}/images/color-effect-bg.png`}
        alt="color-effect-bg"
        fill
      />
    </div>
  );
}
